// src/pages/public/PromoBeta.jsx
// Página pública de captación (redes) en /promo/beta. NO requiere auth.
//   - Usuario logueado  → canjea la beta directo (claimFreeTrialToken con
//                         Authorization Bearer idToken, sin token de email).
//   - Usuario anónimo   → /signup?promo=beta (Signup canjea tras verificar).
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { auth } from '../../firebase';
import EELogo from '../../components/EELogo';

const CLAIM_URL =
  'https://southamerica-east1-mati-edge-elite.cloudfunctions.net/claimFreeTrialToken';

const ORANGE = '#FF6B2C';

export default function PromoBeta() {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const handleActivate = async () => {
    if (busy || authLoading) return;
    setError('');

    // Anónimo → signup con flag promo=beta (el canje ocurre post-verificación).
    if (!user) {
      navigate('/signup?promo=beta');
      return;
    }

    // Logueado → canje directo.
    setBusy(true);
    try {
      const idToken = await auth.currentUser.getIdToken();
      const resp = await fetch(CLAIM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
        body: JSON.stringify({}),
      });
      const data = await resp.json().catch(() => ({}));
      if (resp.ok && data.success) {
        navigate('/dashboard', { replace: true });
      } else {
        setError('No pudimos activar tu acceso. Prueba con un plan.');
        setBusy(false);
      }
    } catch (_e) {
      setError('Ocurrió un problema. Intenta de nuevo.');
      setBusy(false);
    }
  };

  return (
    <div className="mobile-root">
      <section
        className="screen"
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          padding: 0,
        }}
      >
        {/* Header */}
        <div style={{ padding: '22px 24px', borderBottom: '1px solid var(--line)' }}>
          <EELogo size={24} />
        </div>

        {/* Hero */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '32px 24px',
            maxWidth: 520,
            width: '100%',
            margin: '0 auto',
          }}
        >
          <div
            style={{
              display: 'inline-block',
              alignSelf: 'flex-start',
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '0.14em',
              textTransform: 'uppercase',
              color: ORANGE,
              background: '#FFE6D9',
              border: '1px solid #FFCFB5',
              padding: '6px 12px',
              borderRadius: 999,
              marginBottom: 18,
            }}
          >
            Acceso gratis
          </div>

          <h1
            style={{
              fontFamily: 'var(--font-display)',
              fontSize: 40,
              fontWeight: 800,
              letterSpacing: '-0.03em',
              lineHeight: 1.05,
              margin: '0 0 14px',
            }}
          >
            3 días gratis.<br />Sin tarjeta.
          </h1>

          <p style={{ fontSize: 16, color: 'var(--muted)', lineHeight: 1.5, margin: '0 0 30px' }}>
            Accede al motor V6 en vivo — 64+ ligas, señales Over/Under con edge real.
          </p>

          {error && (
            <div
              style={{
                fontSize: 13,
                color: '#B4232A',
                background: '#FDECEC',
                border: '1px solid #F5C2C4',
                borderRadius: 10,
                padding: '10px 12px',
                marginBottom: 14,
              }}
            >
              {error}
            </div>
          )}

          <button
            className="btn-primary accent"
            style={{
              background: ORANGE,
              fontSize: 17,
              fontWeight: 700,
              padding: '18px 24px',
              opacity: busy ? 0.6 : 1,
              pointerEvents: busy ? 'none' : 'auto',
            }}
            onClick={handleActivate}
          >
            {busy ? 'Activando...' : 'Activar acceso gratis →'}
          </button>

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 8,
              justifyContent: 'center',
              marginTop: 18,
              fontSize: 12.5,
              fontWeight: 600,
              color: 'var(--muted)',
            }}
          >
            <span>64+ ligas</span>
            <span style={{ opacity: 0.4 }}>·</span>
            <span>Win rate +56%</span>
            <span style={{ opacity: 0.4 }}>·</span>
            <span>Yield positivo documentado</span>
          </div>

          <p style={{ textAlign: 'center', fontSize: 11.5, color: 'var(--muted)', margin: '22px 0 0', lineHeight: 1.5 }}>
            Acceso por 3 días. No se requiere tarjeta de crédito.
          </p>
        </div>
      </section>
    </div>
  );
}
